/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TypographyMessageText_EmbedMessage = {
    readonly text: string | null;
    readonly " $refType": "TypographyMessageText_EmbedMessage";
};
export type TypographyMessageText_EmbedMessage$data = TypographyMessageText_EmbedMessage;
export type TypographyMessageText_EmbedMessage$key = {
    readonly " $data"?: TypographyMessageText_EmbedMessage$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TypographyMessageText_EmbedMessage">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TypographyMessageText_EmbedMessage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "type": "Message",
  "abstractKey": null
};
(node as any).hash = '4c21f685be6728963c718227941036fd';
export default node;
